import { createSlice } from "@reduxjs/toolkit";
import { GetProductNames } from "services/dropdown/dropdown.service";
import { toast } from 'react-toastify';

export const productNameSlice = createSlice({
  name: "productNames",
  initialState: {
    productNameList: [],
    productNameLoading: false,
    productNameError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetProductNames.pending, (state) => {
      // toast.success('Promise Pending 🤯');
      state.productNameLoading = true
    });

    builder.addCase(GetProductNames.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');
      state.productNameList = action.payload
      state.productNameLoading = false
      state.productNameError = null
    });

    builder.addCase(GetProductNames.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 😣')

      state.productNameLoading = false
      state.productNameError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export default productNameSlice.reducer;
